import { Component } from '@angular/core';

const template = require('!!raw-loader!./anniversary-dice.component.html').default;

@Component({
    selector: 'anniversary-dice',
    template,
    styleUrls: ['./anniversary-dice.component.less'],
})
export class AnniversaryDiceComponent {

}
